import { Routes } from '@angular/router';

import { ZMessagingProvider, ZNotificationsProvider } from '@core/providers';
import { firebaseAuthResolver, mapLibraryResolver } from '@shared/services';
import { MessagingClientService } from '@core/services/messaging-client.service';

import { permissionGuard } from '@core/guards/permission.guard';
import { settingsRoutes } from '@features/settings/settings.routes';
import { MessagingService } from '@gozetta/z-messaging';
import { EGoogleLib } from '@shared/models';
import { liveMapRoutes } from '@features/live-map/live-map.routes';

export const MAIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./main-layout.component').then(m => m.MainLayoutComponent),
    resolve: { firebase: firebaseAuthResolver },
    providers: [
      ZMessagingProvider,
      ZNotificationsProvider,
      {
        provide: MessagingService,
        useClass: MessagingClientService,
      },
    ],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('@features/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'calendar-and-events',
        canActivate: [permissionGuard('CustomerCalenderView')],
        loadComponent: () =>
          import('@features/calender-and-events/calender-and-events.component').then(
            m => m.CalenderAndEventsComponent
          ),
      },
      {
        path: 'historical-vehicles-and-events',
        canActivate: [permissionGuard('CustomerHistoricalVehiclesReportsView')],
        loadComponent: () =>
          import('@features/historical-vehicles-and-events/historical-vehicles-and-events.component').then(
            m => m.HistoricalVehiclesAndEventsComponent
          ),
      },
      {
        path: 'video-requests',
        canActivate: [permissionGuard('CustomerVideoRequestsView')],
        loadComponent: () =>
          import('@features/video-requests/video-requests.component').then(
            m => m.VideoRequestsComponent
          ),
      },

      {
        path: 'incident-reports',
        canActivate: [permissionGuard('CustomerIncidentsReportView')],
        loadComponent: () =>
          import('../../../features/student-incident-reports/student-incident-reports.component').then(
            m => m.StudentIncidentReportsModernComponent
          ),
      },
      {
        path: 'routing-requests',
        resolve: {
          lib: mapLibraryResolver(EGoogleLib.places),
        },
        canActivate: [permissionGuard('CustomerRoutingRequestsView')],
        loadComponent: () =>
          import('@features/routing-requests/routing-requests.component').then(
            m => m.RoutingRequestsComponent
          ),
      },
      {
        path: 'messaging',
        resolve: {
          lib: mapLibraryResolver(EGoogleLib.places),
          lib3: mapLibraryResolver(EGoogleLib.marker),
          lib4: mapLibraryResolver(EGoogleLib.geometry),
        },
        canActivate: [permissionGuard('CustomerMessagesView')],
        loadComponent: () =>
          import('@features/messaging/messaging.component').then(
            m => m.MessagingComponent
          ),
      },
      {
        path: 'contacts-list',
        canActivate: [permissionGuard('CustomerContactsView')],
        loadComponent: () =>
          import('@features/contacts-list/contacts-list.component').then(
            c => c.ContactsListComponent
          ),
      },
      ...settingsRoutes,
      {
        path: '403',
        loadComponent: () =>
          import('@core/pages/miscellaneous/access-denied.component').then(
            m => m.AccessDeniedComponent
          ),
      },
      {
        path: '404',
        loadComponent: () =>
          import('@core/pages/miscellaneous/not-found.component').then(
            m => m.NotFoundComponent
          ),
      },
      ...liveMapRoutes,
    ],
  },
];
